// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_label__-mbyy {
  margin: 0 0 5px 5px;
}

.styles_status__bq4t6 {
  margin-top: 23px;
}

.styles_rowControl__mjPfR {
  padding: 10px 0px 0px 0px;
}

.styles_clearButton__ft84U {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.styles_clearButton__ft84U:hover {
  background: #f44336;
  color: white;
}

.styles_addButtonCol__gOdDg {
  display: flex;
  align-items: center;
}

.styles_clearButtonCol__81bL4 {
  display: flex;
  align-items: center;
}

.styles_loading__8RWaF {
  display: flex;
  align-items: center;
}

.styles_spaceBetween__ObMoo {
  display: flex;
  justify-content: space-between;
}

.styles_containerBanck__nniDE {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 25px;
}

.styles_bankName__HpASG {
  text-transform: uppercase;
}

.styles_bankName__HpASG span {
  text-transform: capitalize;
  margin: 0 5px;
}

.styles_modalHeader__ZW7-K {
  height: 55px;
}

.styles_form__QzfYn {
  width: 900px;
  height: 570px;
}

.styles_footer__zBSph {
  height: 70px;
}

.styles_containerTable__G2jXF {
  position: relative;
  z-index: 99;
}

.styles_tableZ__-5huw {
  position: relative;
  z-index: 99;
}

.styles_table__iDtD6 {
  margin-top: -52px;
  z-index: 1;
}

.styles_tableFinal__eH4po {
  margin-top: -52px;
  z-index: 1;
}

.styles_title__-fUJk {
  font-size: 20px;
  padding-left: 24px;
  height: 20px;
}

.styles_wrapper__vVYOS {
  width: 700px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Financeiro/MovimentacaoBancaria/ListMovimentacaoBancaria/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,0BAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,UAAA;AACF;;AAEA;EACE,iBAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".label {\n  margin: 0 0 5px 5px;\n}\n\n.status {\n  margin-top: 23px;\n}\n\n.rowControl {\n  padding: 10px 0px 0px 0px;\n}\n\n.clearButton {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.clearButton:hover {\n  background: #f44336;\n  color: white;\n}\n\n.addButtonCol {\n  display: flex;\n  align-items: center;\n}\n\n.clearButtonCol {\n  display: flex;\n  align-items: center;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n}\n\n.spaceBetween {\n  display: flex;\n  justify-content: space-between;\n}\n\n.containerBanck {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-left: 25px;\n}\n\n.bankName {\n  text-transform: uppercase;\n}\n\n.bankName span {\n  text-transform: capitalize;\n  margin: 0 5px;\n}\n\n.modalHeader {\n  height: 55px;\n}\n\n.form {\n  width: 900px;\n  height: 570px;\n}\n\n.footer {\n  height: 70px;\n}\n\n.containerTable {\n  position: relative;\n  z-index: 99;\n}\n\n.tableZ {\n  position: relative;\n  z-index: 99;\n}\n\n.table {\n  margin-top: -52px;\n  z-index: 1;\n}\n\n.tableFinal {\n  margin-top: -52px;\n  z-index: 1;\n}\n\n.title {\n  font-size: 20px;\n  padding-left: 24px;\n  height: 20px;\n}\n\n.wrapper {\n  width: 700px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `styles_label__-mbyy`,
	"status": `styles_status__bq4t6`,
	"rowControl": `styles_rowControl__mjPfR`,
	"clearButton": `styles_clearButton__ft84U`,
	"addButtonCol": `styles_addButtonCol__gOdDg`,
	"clearButtonCol": `styles_clearButtonCol__81bL4`,
	"loading": `styles_loading__8RWaF`,
	"spaceBetween": `styles_spaceBetween__ObMoo`,
	"containerBanck": `styles_containerBanck__nniDE`,
	"bankName": `styles_bankName__HpASG`,
	"modalHeader": `styles_modalHeader__ZW7-K`,
	"form": `styles_form__QzfYn`,
	"footer": `styles_footer__zBSph`,
	"containerTable": `styles_containerTable__G2jXF`,
	"tableZ": `styles_tableZ__-5huw`,
	"table": `styles_table__iDtD6`,
	"tableFinal": `styles_tableFinal__eH4po`,
	"title": `styles_title__-fUJk`,
	"wrapper": `styles_wrapper__vVYOS`
};
export default ___CSS_LOADER_EXPORT___;
